module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 68);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-utils");

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = require("@tencent/e-zepto");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/user-client");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/helper");

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

module.exports = require("md5");

/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _tencent_e_zepto__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16);
/* harmony import */ var _tencent_e_zepto__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tencent_e_zepto__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var md5__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37);
/* harmony import */ var md5__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(md5__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1);
/* harmony import */ var _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _tencent_txv_athena_core_user_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26);
/* harmony import */ var _tencent_txv_athena_core_user_client__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_athena_core_user_client__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3);
/* harmony import */ var _tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_7__);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var getCommonParams = /*#__PURE__*/function () {
  var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee() {
    var cookieArr, platformId, params, userRes, token, acctype;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          cookieArr = ['athena_api_imei', 'athena_api_idfa', 'athena_api_guid'];
          _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_5__["cookie"].del(cookieArr);
          platformId = Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_7__["getPlatformId"])();
          /**
           * api接口统一参数platformId
           * platformid兼容礼包领取exchange等后台返回会被限制情况
           */
          params = {
            platformId: platformId,
            platformid: platformId
          };
          if (!(!Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_7__["checkQQ"])() && !Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_7__["checkWX"])())) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", params);
        case 6:
          _context.next = 8;
          return Object(_tencent_txv_athena_core_user_client__WEBPACK_IMPORTED_MODULE_6__["userCookie"])();
        case 8:
          userRes = _context.sent;
          token = userRes.token, acctype = userRes.acctype;
          return _context.abrupt("return", _objectSpread(_objectSpread({}, params), {}, {
            token: token,
            acctype: acctype
          }));
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getCommonParams() {
    return _ref.apply(this, arguments);
  };
}();
var getUniqueKey = function getUniqueKey(_ref2) {
  var url = _ref2.url,
    params = _ref2.params;
  var key = "".concat(url, "_").concat(Object(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_5__["isObject"])(params) ? Object(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_5__["encodeURIJson"])(params) : params);
  return md5__WEBPACK_IMPORTED_MODULE_4___default()(key);
};
var api = {
  origin: window.location.origin,
  timeout: 10000,
  reqList: {},
  /**
   * unique 设置true作用：
   * 根据url与params生成唯一key
   * 页面多个组件同时发出相同key的请求时，只需要发出一次请求，共用一套返回数据即可
   */
  get: function get(url) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$params = options.params,
      params = _options$params === void 0 ? {} : _options$params,
      unique = options.unique;
    var uniqueKey = unique ? getUniqueKey({
      url: url,
      params: params
    }) : '';
    if (uniqueKey && this.reqList[uniqueKey]) {
      return this.reqList[uniqueKey];
    }
    var req = this.ajax(_objectSpread({
      url: url,
      type: 'GET',
      data: params
    }, options));
    if (uniqueKey) {
      this.reqList[uniqueKey] = req;
      req["finally"](function () {
        delete _this.reqList[uniqueKey];
      });
    }
    return req;
  },
  post: function post(url) {
    var _this2 = this;
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var unique = options.unique;
    var uniqueKey = unique ? getUniqueKey({
      url: url,
      params: data
    }) : '';
    if (uniqueKey && this.reqList[uniqueKey]) {
      return this.reqList[uniqueKey];
    }
    var req = this.ajax(_objectSpread({
      url: url,
      type: 'POST',
      data: data
    }, options));
    if (uniqueKey) {
      this.reqList[uniqueKey] = req;
      req["finally"](function () {
        delete _this2.reqList[uniqueKey];
      });
    }
    return req;
  },
  /**
   * 请求发起前对参数做一些拦截修改
   * @param {*} opts
   */
  before: function before() {
    var _arguments = arguments;
    return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee2() {
      var opts, options, _opts$url, url, _opts$data, data, commonParams, _options$params2, params, urlParams;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            opts = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
            options = opts;
            _opts$url = opts.url, url = _opts$url === void 0 ? '' : _opts$url, _opts$data = opts.data, data = _opts$data === void 0 ? {} : _opts$data;
            _context2.next = 5;
            return getCommonParams();
          case 5:
            commonParams = _context2.sent;
            if (!url.includes('//')) {
              options.url = "".concat(api.origin).concat(url);
            }
            if (!(options.type === 'POST')) {
              _context2.next = 12;
              break;
            }
            _options$params2 = options.params, params = _options$params2 === void 0 ? {} : _options$params2;
            urlParams = Object(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_5__["encodeURIJson"])(_objectSpread(_objectSpread({}, commonParams), params));
            options.url = "".concat(options.url).concat(options.url.indexOf('?') > -1 ? '&' : '?').concat(urlParams);
            return _context2.abrupt("return", options);
          case 12:
            return _context2.abrupt("return", _objectSpread(_objectSpread({}, options), {}, {
              data: _objectSpread(_objectSpread({}, commonParams), data)
            }));
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  ajax: function ajax(opts) {
    var _this3 = this;
    return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee3() {
      var options;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this3.before(opts);
          case 2:
            options = _context3.sent;
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              options = _tencent_e_zepto__WEBPACK_IMPORTED_MODULE_3___default.a.extend({}, {
                data: {},
                cache: true,
                dataType: 'json',
                timeout: api.timeout,
                xhrFields: {
                  withCredentials: true
                },
                success: function success() {
                  var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  var rel = res;
                  var code = rel.code;
                  if (code) {
                    rel.code = Number(code);
                  }
                  resolve(rel);
                },
                error: function error(err) {
                  reject(err);
                }
              }, options);
              _tencent_e_zepto__WEBPACK_IMPORTED_MODULE_3___default.a.ajax(options);
            }));
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }
};
/* harmony default export */ __webpack_exports__["default"] = (api);

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ })

/******/ })["default"];